import React from 'react';

import CheckRoundedIcon from '@material-ui/icons/CheckRounded';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import styled from 'styled-components';
import {
  NewStyledIconButton,
  StyledBox,
  StyledButton,
  StyledDivider,
  StyledGrid,
  StyledTypography,
} from 'styles/common';

import { REVIEW_FORM_COMPLETION_STATUS } from 'constants/ProjectConstants';
import { getColorFromKey } from 'constants/helper';

const MeshTab = ({ onChange, active, tabs, icons, disabled }) => {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();
  const handleChange = (activeId) => {
    onChange && onChange(activeId);
  };

  return (
    <StyledGrid container justify="center" alignItems="center" topGutter={5} bottomGutter={5}>
      {tabs &&
        tabs.map((tab, idx) => (
          <React.Fragment key={tab.id}>
            <StyledBox style={{ position: 'relative' }}>
              <BlueBorderButton
                variant="outlined"
                size="large"
                onClick={() => !disabled && handleChange(tab.id)}
                customColor={tab.id === active ? 'primary' : 'white'}
                disableRipple
                disableFocusRipple
                disabled={disabled}
              >
                {tab.status === REVIEW_FORM_COMPLETION_STATUS.IN_PROGRESS && (
                  <NewStyledIconButton
                    style={{ marginRight: '4px' }}
                    padding="none"
                    size="header"
                    color={tab.id === active ? 'white' : 'primary'}
                  >
                    <WarningRoundedIcon />
                  </NewStyledIconButton>
                )}
                {tab.status === REVIEW_FORM_COMPLETION_STATUS.COMPLETED && (
                  <NewStyledIconButton
                    style={{ marginRight: '4px' }}
                    padding="none"
                    size="header"
                    color={tab.id === active ? 'white' : 'primary'}
                  >
                    <CheckRoundedIcon />
                  </NewStyledIconButton>
                )}
                <StyledTypography variant="body2" color={tab.id === active ? 'white' : 'primary'} clickable>
                  {tab.title === 'Goal Review' ? `${moduleName} Review` : tab.title}
                </StyledTypography>
              </BlueBorderButton>
              {tab.subtitle && (
                <SubtitleText variant="body2" color="primary">
                  {tab.subtitle}
                </SubtitleText>
              )}
            </StyledBox>
            {idx !== tabs.length - 1 ? <StyledDivider length={8} thickness={0.5} color="lightGrey" /> : null}
          </React.Fragment>
        ))}
    </StyledGrid>
  );
};

export default MeshTab;

const BlueBorderButton = styled(StyledButton)`
  border-color: ${(props) => props.theme.palette.primary.main};
  min-width: 12rem;
  width: 14rem;
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;

  background-color: ${(props) => getColorFromKey(props.customColor)};
  opacity: 0.8;

  &:hover {
    opacity: 1;
    background-color: ${(props) => getColorFromKey('primary')};
    p {
      color: white;
    }
    svg {
      fill: white;
    }
  }
`;

const SubtitleText = styled(StyledTypography)`
  position: absolute;
  padding: 0.25rem 0 0 0.25rem;
  width: 100%;
  text-align: center;
`;
